import { UpsertUserAccountModel } from "../../main/models/upsert-user-account-model";
import { post } from "./utils";

export const upsertUserAccount = async (url: string, addUserAccount: UpsertUserAccountModel) =>
  await post(url, addUserAccount);
